import React from 'react';
import { Paper, Stack, TextField, Typography } from '@mui/material';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import Autocomplete from '@mui/material/Autocomplete';

interface Props {
  canWrite: boolean;
  availableVendors: any;
  selectedVendor: any[];
  setSelectedVendor: any;
  isPartnerAccount: boolean;
}

export const VendorSection = ({
  isPartnerAccount,
  canWrite,
  availableVendors,
  setSelectedVendor,
  selectedVendor,
}: Props) => {
  return (
    <Paper sx={{ padding: '1rem' }}>
      <Stack gap="0.5rem">
        <Typography variant="subtitle1" color="primary">
          <LooksOneIcon /> {isPartnerAccount ? 'Dealer' : 'Aftermarket Vendor'}
        </Typography>

        <Autocomplete
          size="small"
          multiple
          value={availableVendors.filter((vendor: any) => selectedVendor.find(sv => sv.value === vendor.value))}
          onChange={(event, newValues) => {
            setSelectedVendor(newValues);
          }}
          options={availableVendors}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={option => option.label}
          disabled={!canWrite}
          renderInput={params => (
            <TextField
              required
              {...params}
              label={`Select the ${isPartnerAccount ? 'Dealers that have access to this product' : 'Vendor'}`}
              variant="outlined"
            />
          )}
        />
      </Stack>
    </Paper>
  );
};
